import React, { useState } from "react";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";

// import JS files
import MuiModal from "../../../shares/MuiModal";

// import Others files

const EmployeeInfoModal = (props) => {
  return (
    <>
      <MuiModal
        openModal={props.openModal}
        setOpenModal={props.setOpenModal}
        width="w-3/5"
      >
        <div>
          <div className="flex justify-center mb-8">
            <img
              className="w-16 h-16 md:w-32 md:h-32 rounded-full"
              src={props.attach_file}
            />
          </div>
          <div class="mb-4 grid md:grid-cols-3 gap-4">
            <div className="flex items-center">
              <KeyboardDoubleArrowLeftIcon
                sx={{ fontSize: "1.25rem", color: "#adb5bd" }}
              />
              <span className="show-label">
                نام و نام‌خانوادگی:{" "}
                <span className="show-value">{props.name}</span>
              </span>
            </div>
            {/* <div className="flex items-center">
              <KeyboardDoubleArrowLeftIcon
                sx={{ fontSize: "1.25rem", color: "#adb5bd" }}
              />
              <span className="show-label">
                نام فروشگاه:{" "}
                <span className="show-value">{props.store_name}</span>
              </span>
            </div> */}
            <div className="flex items-center">
              <KeyboardDoubleArrowLeftIcon
                sx={{ fontSize: "1.25rem", color: "#adb5bd" }}
              />
              <span className="show-label">
                شماره همراه:{" "}
                <span className="show-value"> {props.phone_number} </span>
              </span>
            </div>
            <div className="flex items-center">
              <KeyboardDoubleArrowLeftIcon
                sx={{ fontSize: "1.25rem", color: "#adb5bd" }}
              />
              <span className="show-label">
                شماره تلفن: <span className="show-value"> {props.phone}</span>
              </span>
            </div>
            <div className="flex items-center">
              <KeyboardDoubleArrowLeftIcon
                sx={{ fontSize: "1.25rem", color: "#adb5bd" }}
              />
              <span className="show-label">
                نام کاربری: <span className="show-value"> {props.user}</span>
              </span>
            </div>
            <div className="flex items-center">
              <KeyboardDoubleArrowLeftIcon
                sx={{ fontSize: "1.25rem", color: "#adb5bd" }}
              />
              <span className="show-label">
                شهر: <span className="show-value"> {props.city} </span>
              </span>
            </div>
            <div className="flex items-center mb-4">
              <span className="show-label">
                <KeyboardDoubleArrowLeftIcon
                  sx={{ fontSize: "1.25rem", color: "#adb5bd" }}
                />
                ایمیل: <span className="show-value"> {props.email}</span>
              </span>
            </div>
          </div>

          <div className="flex items-center">
            <span className="show-label">
              <KeyboardDoubleArrowLeftIcon
                sx={{ fontSize: "1.25rem", color: "#adb5bd" }}
              />
              آدرس: <span className="show-value"> {props.address} </span>
            </span>
          </div>
        </div>
      </MuiModal>
    </>
  );
};

export default EmployeeInfoModal;
